import React, {Component} from 'react';
import PageTransition from 'react-router-page-transition';

import { Nav, NavItem, Grid } from 'react-bootstrap';
import { IndexLinkContainer } from 'react-router-bootstrap';

import '../styles/Content.less';

export default class Content extends Component{

    componentDidMount() {
        if (window.location.pathname != "/") {
            this._div.scrollIntoView()
        }
    }

    render() {
        return (
            <div className="content-wrapper" ref={(ref) => this._div = ref}>
                <section className="navigation">
                    <Grid>
                        <Nav className="nav nav-pills nav-justified">
                            <IndexLinkContainer to="/">
                                <NavItem><i className="fp fp-home"/> Home</NavItem>
                            </IndexLinkContainer>
                            <IndexLinkContainer to="/about">
                                <NavItem><i className="fp fp-business-card"/> Über mich</NavItem>
                            </IndexLinkContainer>
                            <IndexLinkContainer to="/pricing">
                                <NavItem><i className="fp fp-ticket"/> Preise</NavItem>
                            </IndexLinkContainer>
                            <IndexLinkContainer to="/events">
                                <NavItem><i className="fp fp-calendar"/> Events</NavItem>
                            </IndexLinkContainer>
                            <IndexLinkContainer to="/news">
                                <NavItem><i className="fp fp-calendar"/> News</NavItem>
                            </IndexLinkContainer>
                            <IndexLinkContainer to="/contact">
                                <NavItem><i className="fp fp-location2"/> Kontakt</NavItem>
                            </IndexLinkContainer>
                        </Nav>
                    </Grid>
                </section>
                <section className="content">
                    <Grid>
                        <PageTransition timeout={600}>
                            {this.props.children}
                        </PageTransition>
                    </Grid>
                </section>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Content.js